export const WEATHER_MAP_LAYOUT_ORIENTATIONS = Object.freeze({
  horizontal: 'horizontal',
  vertical: 'vertical',
});

export const WEATHER_MAP_RESIZABLE_LAYOUT_DEFAULTS = Object.freeze({
  resizableOrientation: WEATHER_MAP_LAYOUT_ORIENTATIONS.horizontal,
  nonResizableOrientation: WEATHER_MAP_LAYOUT_ORIENTATIONS.vertical,
  mapDefaultSize: '65%',
  panelDefaultSize: '35%',
  mapMinSize: '30%',
  panelMinSize: '20%',
});
